<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Introdução
      </h2>
      <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
        Olá! Na aba Monitoramento do Diagnóstico Técnico você encontra o filtro: Unidade(s) posicionado do
        lado esquerdo. Neste filtro você poderá selecionar a(s) unidade(s) que pretende monitorar, e será possível
        analisar, por meio de gráficos e tabelas, a participação dos servidores no diagnóstico técnico da(s)
        unidade(s) selecionadas.
      </p>
    </div>

    <div>
      <h2>
        Gráficos e Tabelas
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          O velocímetro apresenta o percentual de servidores que concluíram todas as avaliações técnicas
          disponíveis.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          A tabela apresenta a lista dos servidores da(s) unidade(s) selecionada(s), a categoria (gestor ou servidor) e
          quais avaliações já realizaram. <br>
          Em cada coluna da tabela é possível utilizar os recursos de ordenação, de forma crescente ou decrescente,
          podendo ainda realizar pesquisa por qualquer termo da tabela.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na sequência são apresentados os servidores dispensados de participar do diagnóstico técnico.
        </p>
      </div>
    </div>

    <div>
      <h2>Importante!</h2>
      <div class="mx-2 pa-2 justify-center">
        <p class="text-start font-weight-medium info--text text-lg-h6">
          Recomenda-se visitar essa aba para acompanhar a evolução da participação dos servidores no período do
          Diagnóstico Técnico.
        </p>
      </div>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../../BaseTutorial';

export default {
  name: 'TutorialMonitoramentoDiagnosticoTecnico',
  components: { BaseTutorial },
  data: () => ({
    steps: [
      'Introdução',
      'Gráficos e Tabelas',
      'Importante',
    ],
  }),
};
</script>

<style></style>
